import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../utilities/context";
import Container from "@mui/material/Container";
import LayoutCustomer from "./LayoutCustomer";
// import Grid from "@mui/material/Grid";
// import Styles from "../../public/assets/css/main.css";
import { Grid, Typography } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
// import CustomFilterDataGrid from "./CustomFilterDataGrid";

const CustomerHelp = () => {
  const intl = useIntl();
  const context = useContext(AppContext);

  useEffect(() => {
  }, []);

  return (
    <LayoutCustomer>
      <Container maxWidth={false} disableGutters>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" component="div">
              <FormattedMessage
                id="app.header.help.label"
                defaultMessage="Ayuda"
              />
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <List dense={false}>
              <ListItem>
                <ListItemIcon>
                  <PlaylistAddCheckIcon />
                </ListItemIcon>
                <Link to={"/terms"}>
                  <FormattedMessage
                    id="app.terms.title"
                    defaultMessage="Términos y Condiciones de QRDoor.click"
                  />
                </Link>
              </ListItem>
            </List>
          </Grid>
          {/* <Grid item xs={12}>
          <CustomFilterDataGrid rows={rows} columns={columns} />
          </Grid> */}
        </Grid>
      </Container>
    </LayoutCustomer>
  );
};

export default CustomerHelp;
